import React, { Component } from 'react'
import { Popover, Button } from 'hljd'
import { PROPERTY_WITH_WEDDING } from '../../constant'
import Style from './style.module.less'

class AddBudget extends Component {
  constructor(props) {
    super(props)
    this.state = { visible: false, selectKey: [] }
  }

  changeVisible = visible => {
    if (!visible) {
      this.setState({
        visible: false,
        selectKey: []
      })
    } else {
      this.setState({
        visible: true,
        selectKey: [...this.props.value]
      })
    }
  }

  onOk = () => {
    const { onChange, onOk } = this.props
    onChange && onChange(this.state.selectKey)
    onOk && onOk(this.state.selectKey)
    this.changeVisible(false)
  }

  selectChange = value => {
    let { selectKey } = this.state
    const idx = selectKey.findIndex(item => item == value)
    if (idx >= 0) {
      selectKey.splice(idx, 1)
    } else {
      selectKey.push(value)
    }
    this.setState({
      selectKey
    })
  }

  render() {
    const { visible, selectKey } = this.state
    const { show } = this.props
    return (
      <Popover
        trigger="click"
        overlayClassName={Style['add-budget-wrap']}
        placement="bottomRight"
        visible={visible}
        onVisibleChange={this.changeVisible}
        content={
          <div className="add-budget-body">
            <ul className="clearfix">
              {PROPERTY_WITH_WEDDING.map(item => {
                const idx = selectKey.findIndex(key => key == item.id)
                return (
                  <li
                    key={item.id}
                    className={idx >= 0 ? 'active' : ''}
                    onClick={() => this.selectChange(item.id)}
                  >
                    {item.name}
                  </li>
                )
              })}
            </ul>
            <div className="add-budget-footer">
              <Button onClick={() => this.changeVisible(false)}>取消</Button>
              <Button type="primary" onClick={this.onOk}>
                提交
              </Button>
            </div>
          </div>
        }
      >
        <Button
          type="primary"
          className="fr"
          onClick={() => this.changeVisible(true)}
          style={{ display: show ? 'inline-block' : 'none' }}
        >
          添加新需求
        </Button>
      </Popover>
    )
  }
}

export default AddBudget
